// Wave-J (loop-engineering nota-10) — REACH da triagem: needs_human vira ping
// REAL, não linha de log. Dois canais, ambos best-effort (nunca derrubam nada):
//   1. Notificação NATIVA do macOS (Electron renderer Notification) — default.
//   2. Webhook outbound OPCIONAL: <root>/.apolo/notify.json {"webhookUrl": "..."}
//      → POST {text} (formato compatível com Slack/Discord/genérico). O usuário
//      cola a URL do workspace dele; sem arquivo = só nativa.

const NOTIFY_REL_PATH = '.apolo/notify.json'; // mesma convenção canônica .apolo/ (E9-T02)

function bridge() {
  const w = /** @type {any} */ (typeof window !== 'undefined' ? window : null);
  return w || null;
}

export function notifyNative(title, body) {
  try {
    const w = bridge();
    if (!w?.Notification) return false;
    if (w.Notification.permission === 'denied') return false;
    // Electron renderer: permission é 'granted' por default; web pede na hora.
    if (w.Notification.permission !== 'granted' && w.Notification.requestPermission) {
      w.Notification.requestPermission().catch(() => {});
    }
    void new w.Notification(String(title).slice(0, 80), { body: String(body || '').slice(0, 240) });
    return true;
  } catch { return false; }
}

async function readNotifyConfig(root) {
  try {
    const api = bridge()?.apolo;
    if (!root || !api?.file?.read) return null;
    const r = await api.file.read({ root, filePath: NOTIFY_REL_PATH });
    if (!r || r.ok === false || typeof r.content !== 'string') return null;
    const cfg = JSON.parse(r.content);
    return typeof cfg?.webhookUrl === 'string' && /^https:\/\//.test(cfg.webhookUrl) ? cfg : null;
  } catch { return null; }
}

export async function notifyWebhook(root, text) {
  try {
    const cfg = await readNotifyConfig(root);
    if (!cfg) return false;
    const res = await fetch(cfg.webhookUrl, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ text: String(text).slice(0, 500) }),
    });
    return !!res?.ok;
  } catch { return false; }
}

/** Ação da triagem: needs_human ⇒ nativa sempre + webhook se configurado. Outras classes: silencioso (lição/telemetria cobrem).
 * @param {{root?: string, sessionId?: string, triage?: any}} [args] */
export async function dispatchRunTriage({ root, sessionId, triage } = {}) {
  try {
    if (!triage || triage.action !== 'notify') return false;
    const text = `${triage.title}\n${triage.detail}${sessionId ? `\n(sessão ${String(sessionId).slice(0, 8)})` : ''}`;
    const native = notifyNative(triage.title, triage.detail);
    const hook = await notifyWebhook(root, text);
    return native || hook;
  } catch { return false; }
}
